module.exports = __webpack_public_path__ + "static/img/swipe-2-2.1a387ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CloudQuickPrinting/swipe-2-2.png
// module id = /oBP
// module chunks = 10